import { yup } from '@framework/validation/initYup.ts';
import { WidgetRepository } from './repository/WidgetRepository.ts';
import { type Widget } from './Widget.ts';

/**
 * Validatore lazy per un qualunque tipo di widget.
 */
export const LazyWidgetSchema = yup.lazy(
  (value: Widget | undefined): yup.ObjectSchema<Widget> => {
    const widgetType = WidgetRepository.find(value?.type);

    if (!widgetType?.configValidator) {
      // Forzo la tipizizzazione: il campo verrebbe comunque rimosso e a noi non interessa.
      // In teoria non dovrebbe mai capitare.
      return yup
        .object()
        .meta({ widget: value?.type ?? 'unknown' })
        .notRequired()
        .strip() as unknown as yup.ObjectSchema<Widget>;
    }
    return widgetType.configValidator.noUnknown().meta({
      widget: widgetType.type,
    }) as yup.ObjectSchema<Widget>;
  },
) as yup.Lazy<Widget>;
